<template>
  <div class="numeric-entry-component-container">
    <div
      v-if="answered"
      class="answered"
    >
      <label>Answer:</label>
      <div class="answer selected">
        <div
          :class="{correct: correct}"
          class="icon"
        />
        {{ correct ? correctAnswer : number }} {{ unit }}
      </div>
      <div
        v-if="!correct"
        class="answer"
      >
        <div class="correct icon" />
        {{ correctAnswer }} {{ unit }}
      </div>
    </div>
    <div
      v-else
      class="unanswered"
    >
      <input
        v-model="number"
        type="number"
        @blur="blur"
        @focus="focus"
      >
      <label>{{ unit }}</label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    answered: {
      type: Boolean,
      default: false,
    },
    correct: {
      type: Boolean,
      default: false,
    },
    flashcard: {
      type: Object,
      default: () => ({}),
    },
    flashcardState: {
      type: Object,
      default: () => ({}),
    },
    rawAnswerData: {
      type: Object,
    },
  },
  emits: ['set-raw-answer-data'],
  computed: {
    correctAnswer() {
      return JSON.parse(this.flashcard.answers[0].text).numeric;
    },
    unit() {
      return JSON.parse(this.flashcard.answers[0].text).unit;
    },
    number: {
      get() {
        if (this.flashcardState.rawAnswerData) {
          return this.flashcardState.rawAnswerData.numeric;
        }
        return this.rawAnswerData ? this.rawAnswerData.numeric : null;
      },
      set(value) {
        this.$emit('set-raw-answer-data', {numeric: value});
      },
    },
  },
  created() {
    this.$emit('set-raw-answer-data', {numeric: null});
  },
  methods: {
    blur() {
      this.$store.commit('appState/setInputtingText', false);
    },
    focus() {
      this.$store.commit('appState/setInputtingText', true);
    },
  },
};
</script>

<style lang='scss' scoped>
  .numeric-entry-component-container {
    margin: rem-calc(32) 0;

    .unanswered {
      label {
        display: inline-block;
      }

      input {
        background: #dfe3e9;
        border: solid 1px rgba(0,0,0,0.1);
        border-radius: 4px;
        margin-right: rem-calc(4);
        padding: rem-calc(6);
        text-align: right;
        width: rem-calc(80);

        &::-webkit-inner-spin-button, &::-webkit-outer-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
      }
    }

    .answered {
      label {
        font-size: rem-calc(18);
      }

      .icon {
        @include incorrect-svg(#FA726F);
        background-size: contain;
        height: rem-calc(16);
        margin-right: rem-calc(12);
        width: rem-calc(16);

        &.correct {
          @include correct-svg(#70CF63);
        }
      }

      .answer {
        align-items: center;
        display: flex;
        margin-top: rem-calc(16);
      }

      .selected {
        font-weight: $semi-bold;
      }
    }
  }
</style>
